import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { ThemeProvider } from './contexts/ThemeContext';
import './utils/axios'; // Initialize axios defaults
import { setupInterceptors } from './services/setupInterceptors';

// Set up API interceptors after store is created
setupInterceptors(store);

// Monitor and fix aria-hidden on root element
// MUI Dialog/Modal components sometimes set aria-hidden on the root and don't clean it up properly
const rootElement = document.getElementById('root');
if (rootElement) {
  // Use MutationObserver to watch for aria-hidden changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        // Check if any dialog is actually open
        const hasOpenDialog = document.querySelector('[role="dialog"], [role="presentation"]');
        if (!hasOpenDialog && rootElement.getAttribute('aria-hidden') === 'true') {
          rootElement.removeAttribute('aria-hidden');
        }
      }
    });
  });

  observer.observe(rootElement, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);